module.exports = __webpack_public_path__ + "img/bansui.b88592a6.png";